const dataSourceInternalProperties = [
  'condition',
  'brand',
  'identifier_exists',
  'sku',
  'title',
  'description',
  'product_type',
  'product_category',
  'item_group_id',
  'availability',
  'weight',
  'gtin',
  'mpn',
  'link',
  'size',
  'gender',
  'regions',
]


export {dataSourceInternalProperties};
